'use client';

import { usePathname } from 'next/navigation';

export const useLoggedIn = () => {
  const pathname = usePathname();

  return pathname.startsWith('/bestandskunden/');
};
